import Table from './table.vue';
export default Table;


// WEBPACK FOOTER //
// ./node_modules/iview/src/components/table/index.js